import useSEO from '../../hooks/useSEO';

export default function PrivacyPolicy() {
  // SEO dinámico
  useSEO({
    title: "Política de Privacidad | SEOgenia",
    description: "Política de Privacidad de SEOgenia. Información sobre el tratamiento de datos personales, derechos de los usuarios y cumplimiento del RGPD.",
    keywords: "política privacidad, protección datos, rgpd, gdpr, privacidad seogenia",
    canonical: "https://seogenia.es/politica-privacidad",
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Política de Privacidad",
      "description": "Política de Privacidad de SEOgenia",
      "url": "https://seogenia.es/politica-privacidad"
    }
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Política de Privacidad</h1>
          <p className="text-lg sm:text-xl opacity-90">Última actualización: 15 de enero de 2025</p>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Información al Usuario</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>SEOgenia</strong>, en adelante RESPONSABLE, es el Responsable del tratamiento de los datos personales del Usuario y le informa que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679 de 27 de abril de 2016 (GDPR) relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos, por lo que se le facilita la siguiente información del tratamiento:
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Fin del tratamiento:</strong> mantener una relación comercial con el Usuario. Las operaciones previstas para realizar el tratamiento son:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
              <li>Remisión de comunicaciones comerciales publicitarias por email, fax, SMS, MMS, comunidades sociales o cualquier otro medio electrónico o físico, presente o futuro, que posibilite realizar comunicaciones comerciales.</li>
              <li>Realizar estudios de mercado y análisis estadísticos.</li>
              <li>Tramitar encargos, solicitudes o cualquier tipo de petición que sea realizada por el usuario a través de cualquiera de las formas de contacto que se ponen a su disposición.</li>
              <li>Remitir el boletín informativo online, sobre novedades, ofertas y promociones en nuestra actividad.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Criterios de Conservación de los Datos</h2>
            <p className="text-gray-700 leading-relaxed">
              Los datos se conservarán mientras se mantenga la relación comercial o durante los años necesarios para cumplir con las obligaciones legales. Los datos proporcionados se conservarán mientras no se solicite el cese de la actividad por el interesado.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Comunicación de Datos Personales</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              No se comunicarán los datos a terceros, salvo obligación legal. Los datos podrán ser comunicados a:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Organismos de la Administración Pública con competencia en los sectores de actividad cuando así lo establezca la normativa vigente.</li>
              <li>Proveedores de servicios tecnológicos necesarios para la prestación del servicio.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Derechos que Asisten al Usuario</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              El Usuario puede ejercer los siguientes derechos:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li><strong>Derecho de acceso:</strong> Permite al interesado conocer y obtener información sobre sus datos de carácter personal sometidos a tratamiento.</li>
              <li><strong>Derecho de rectificación o supresión:</strong> Permite corregir errores y modificar los datos que resulten ser inexactos o incompletos.</li>
              <li><strong>Derecho de cancelación:</strong> Permite que se supriman los datos que resulten ser inadecuados o excesivos.</li>
              <li><strong>Derecho de oposición:</strong> Derecho del interesado a que no se lleve a cabo el tratamiento de sus datos de carácter personal o se cese en el mismo.</li>
              <li><strong>Limitación del tratamiento:</strong> Conlleva el marcado de los datos personales conservados, con el fin de limitar su futuro tratamiento.</li>
              <li><strong>Portabilidad de los datos:</strong> Facilitación de los datos objeto de tratamiento al interesado, para que éste pueda transmitirlos a otro responsable, sin impedimentos.</li>
              <li><strong>Derecho a no ser objeto de decisiones individualizadas automatizadas (incluida la elaboración de perfiles):</strong> Derecho a no ser objeto de una decisión basada en el tratamiento automatizado que produzca efectos o afecte significativamente.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              El Usuario podrá ejercitar sus derechos mediante comunicación escrita dirigida al responsable con la referencia "GDPR-seogenia.es", especificando:
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
              <li>Nombre, apellidos del Usuario y copia del DNI.</li>
              <li>Petición en que se concreta la solicitud.</li>
              <li>Domicilio a efecto de notificaciones.</li>
              <li>Fecha y firma del solicitante.</li>
              <li>Todo documento que acredite la petición que formula.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Esta solicitud y todo otro documento adjunto podrá enviarse a la siguiente dirección y/o correo electrónico:
            </p>
            <p className="text-gray-700 leading-relaxed mt-2">
              <strong>Dirección postal:</strong> Madrid, España<br />
              <strong>Correo electrónico:</strong> info@seogenia.es
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Enlaces a Sitios Web de Terceros</h2>
            <p className="text-gray-700 leading-relaxed">
              El Sitio Web puede incluir hipervínculos o enlaces que permiten acceder a páginas web de terceros distintos de SEOgenia. Los titulares de dichos sitios web dispondrán de sus propias políticas de protección de datos, siendo ellos mismos, en cada caso, responsables de sus propios ficheros y de sus propias prácticas de privacidad.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Reclamaciones ante la Autoridad de Control</h2>
            <p className="text-gray-700 leading-relaxed">
              En caso de que el Usuario considere que existe un problema o infracción de la normativa vigente en la forma en la que se están tratando sus datos personales, tendrá derecho a la tutela judicial efectiva y a presentar una reclamación ante una autoridad de control, en particular, en el Estado en el que tenga su residencia habitual, lugar de trabajo o lugar de la supuesta infracción. En el caso de España, la autoridad de control es la Agencia Española de Protección de Datos (https://www.aepd.es/).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Aceptación y Cambios en esta Política de Privacidad</h2>
            <p className="text-gray-700 leading-relaxed">
              Es necesario que el Usuario haya leído y esté conforme con las condiciones sobre la protección de datos de carácter personal contenidas en esta Política de Privacidad, así como que acepte el tratamiento de sus datos personales para que el Responsable del tratamiento pueda proceder al mismo en la forma, durante los plazos y para las finalidades indicadas. El uso del Sitio Web implicará la aceptación de la Política de Privacidad del mismo.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              SEOgenia se reserva el derecho a modificar su Política de Privacidad, de acuerdo a su propio criterio, o motivado por un cambio legislativo, jurisprudencial o doctrinal de la Agencia Española de Protección de Datos. Los cambios o actualizaciones de esta Política de Privacidad serán notificados de forma explícita al Usuario.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Datos de Contacto</h2>
            <p className="text-gray-700 leading-relaxed">
              Para cualquier consulta sobre esta Política de Privacidad o sobre el tratamiento de sus datos personales, puede contactar con nosotros:
            </p>
            <div className="bg-gray-50 rounded-xl p-6 mt-4">
              <p className="text-gray-700"><strong>Email:</strong> info@seogenia.es</p>
              <p className="text-gray-700"><strong>Teléfono:</strong> +34 659 357 423</p>
              <p className="text-gray-700"><strong>Dirección:</strong> Madrid, España</p>
            </div>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-500 font-semibold transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            Volver al inicio
          </a>
        </div>
      </div>
    </div>
  );
}
